import ObjectsIsEquals from '@/lib/utils/ObjectsIsEquals'

export function objectsIsEquals(obj1, obj2) {
  return ObjectsIsEquals(obj1, obj2)
}

export function getThemePreviewUrlParameters(params, lastParam) {
  let url = '?preview_theme_customs=1'
  for (const key in params) {
    url = url != '' ? (url += '&') : url
    let data = params[key]
    if (typeof data === 'object') {
      if (key.includes('crop')) data = JSON.stringify(data.coords)
      else data = JSON.stringify(data)
    }
    url += `${key}=${encodeURIComponent(data)}`
  }
  return `${url}&preview_theme_customs_display=${lastParam}`
}

export function getObjectWithoutCache(obj) {
  return Object.assign({}, obj)
}
